import { Map, fromJS } from 'immutable'
import { RxCustomerAPI } from '@driftt/dapper'
import { UserStatus } from '../../user/constants'

const patchProperties = (userId, patchOperation) => {
  return RxCustomerAPI
    .patch(`/users/${userId}/properties2`, patchOperation)
    .checkStatus()
    .mapResponse(fromJS)
}

export const api = {
  fetch(userId) {
    return RxCustomerAPI
      .get(`/users/${userId}/properties`)
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(fromJS)
  },

  update(userId, properties) {
    return RxCustomerAPI
      .patch(`/users/${userId}/properties`, properties)
      .checkStatus()
      .mapResponse(fromJS)
  },

  patchClassificationNotificationProperties(userId, properties) {
    const patchOperation = [{ "property": "classifications-to-notify-on", "operation": "set", "value": properties['classifications-to-notify-on'] }]
    return patchProperties(userId, patchOperation)
  },
  patchExtensionProperties(userId, { newProperties, existingExtensionUserProperties }) {
    const mergedProperties = existingExtensionUserProperties
      ? { ...existingExtensionUserProperties.toJS(), ...newProperties }
      : { ...newProperties }
    const patchOperation = [{ "property": "extensionSettings", "operation": "set", "value": mergedProperties }]
    return patchProperties(userId, patchOperation)
  },
  patchOutboundNotificationProperties(userId, properties) {
    const patchOperation = [{ "property": "outboundNotificationSettings", "operation": "set", "value": properties['outboundNotificationSettings'] }]
    return patchProperties(userId, patchOperation)
  },
  fetchUsersByPropertyName(orgId, properties) {
    return RxCustomerAPI
      .get(`/organizations/${orgId}/users/properties`, { name: properties, status: [UserStatus.INVITED, UserStatus.ENABLED]})
      .checkStatus()
      .mapResponse(fromJS)
      .map((entries) => {
        return entries.reduce((result, entry) => {
          return result.update(entry.get('name'), Map(), (value) => {
            return value.set(entry.get('objectId'), Map({
              value: entry.get('value'),
              updatedAt: entry.get('updatedAt'),
            }))
          })
        }, Map())
      })
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/properties/api.js